export const BUTTON = 'button';
export const DROPDOWN = 'dropdown';
export const SAVE_FILTER = 'Save filter';
export const UPDATE_FILTER = 'Update existing filter';
